// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_sba.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * One SBA program / socio-economic certification of a company.
 *
 * @generated from message mono.datagateway.v1.SbaCertFact
 */ export class SbaCertFact extends Message {
    static fromBinary(bytes, options) {
        return new SbaCertFact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SbaCertFact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SbaCertFact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SbaCertFact, a, b);
    }
    constructor(data){
        super(), /**
   * 8A | 8A_JV | HUBZONE | WOSB | EDWOSB | SDVOSB | VOSB | SDB
   *
   * @generated from field: string code = 1;
   */ _define_property(this, "code", ""), /**
   * "8(a)", "HUBZone", …
   *
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * sba_certified | self_represented
   *
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * YYYY-MM-DD or ""
   *
   * @generated from field: string entry_date = 4;
   */ _define_property(this, "entryDate", ""), /**
   * YYYY-MM-DD or ""
   *
   * @generated from field: string exit_date = 5;
   */ _define_property(this, "exitDate", ""), /**
   * sam_api | sam_extract (formatPublicProvenance)
   *
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string as_of = 7;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: bool stale = 8;
   */ _define_property(this, "stale", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SbaCertFact, "runtime", proto3);
_define_property(SbaCertFact, "typeName", "mono.datagateway.v1.SbaCertFact");
_define_property(SbaCertFact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "entry_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "exit_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * A party of an agreement as the viewer sees it.
 *
 * @generated from message mono.datagateway.v1.SbaMpParty
 */ export class SbaMpParty extends Message {
    static fromBinary(bytes, options) {
        return new SbaMpParty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SbaMpParty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SbaMpParty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SbaMpParty, a, b);
    }
    constructor(data){
        super(), /**
   * empty when not in the viewer's registry
   *
   * @generated from field: string registry_id = 1;
   */ _define_property(this, "registryId", ""), /**
   * uei:<UEI> | sbaname:<hash>
   *
   * @generated from field: string public_key = 2;
   */ _define_property(this, "publicKey", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string uei = 5;
   */ _define_property(this, "uei", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SbaMpParty, "runtime", proto3);
_define_property(SbaMpParty, "typeName", "mono.datagateway.v1.SbaMpParty");
_define_property(SbaMpParty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One agreement seen from a company's side.
 *
 * @generated from message mono.datagateway.v1.SbaMpLink
 */ export class SbaMpLink extends Message {
    static fromBinary(bytes, options) {
        return new SbaMpLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SbaMpLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SbaMpLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SbaMpLink, a, b);
    }
    constructor(data){
        super(), /**
   * MENTOR (this company mentors) | PROTEGE
   *
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: mono.datagateway.v1.SbaMpParty other = 2;
   */ _define_property(this, "other", void 0), /**
   * YYYY-MM-DD
   *
   * @generated from field: string approved_on = 3;
   */ _define_property(this, "approvedOn", ""), /**
   * YYYY-MM-DD when off the list
   *
   * @generated from field: string ended_on = 4;
   */ _define_property(this, "endedOn", ""), /**
   * "SBA list: …" (canonical tokens)
   *
   * @generated from field: repeated string cert_types = 5;
   */ _define_property(this, "certTypes", []), /**
   * raw tokens, shown as is
   *
   * @generated from field: repeated string cert_types_unmapped = 6;
   */ _define_property(this, "certTypesUnmapped", []), /**
   * when projected to company_relationships
   *
   * @generated from field: string relationship_id = 7;
   */ _define_property(this, "relationshipId", ""), /**
   * pending name-match candidate
   *
   * @generated from field: string candidate_id = 8;
   */ _define_property(this, "candidateId", ""), /**
   * sba_mp_xlsx
   *
   * @generated from field: string source = 9;
   */ _define_property(this, "source", ""), /**
   * snapshot as_of
   *
   * @generated from field: string as_of = 10;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: string naics = 11;
   */ _define_property(this, "naics", ""), /**
   * The registry companies the pending name-match candidate asks about
   * ("Is this {name} ({state})?"): registry_id + name only.
   *
   * @generated from field: repeated mono.datagateway.v1.SbaMpParty candidate_options = 12;
   */ _define_property(this, "candidateOptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SbaMpLink, "runtime", proto3);
_define_property(SbaMpLink, "typeName", "mono.datagateway.v1.SbaMpLink");
_define_property(SbaMpLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "other",
            kind: "message",
            T: SbaMpParty
        },
        {
            no: 3,
            name: "approved_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ended_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cert_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "cert_types_unmapped",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "relationship_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "naics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "candidate_options",
            kind: "message",
            T: SbaMpParty,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SbaSnapshotInfo
 */ export class SbaSnapshotInfo extends Message {
    static fromBinary(bytes, options) {
        return new SbaSnapshotInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SbaSnapshotInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SbaSnapshotInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SbaSnapshotInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string as_of = 1;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: string file_name = 2;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: bool stale = 3;
   */ _define_property(this, "stale", false), /**
   * @generated from field: bool loaded = 4;
   */ _define_property(this, "loaded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SbaSnapshotInfo, "runtime", proto3);
_define_property(SbaSnapshotInfo, "typeName", "mono.datagateway.v1.SbaSnapshotInfo");
_define_property(SbaSnapshotInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "loaded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompanySbaProfileRequest
 */ export class GetCompanySbaProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanySbaProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanySbaProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanySbaProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanySbaProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: bool include_ended = 2;
   */ _define_property(this, "includeEnded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanySbaProfileRequest, "runtime", proto3);
_define_property(GetCompanySbaProfileRequest, "typeName", "mono.datagateway.v1.GetCompanySbaProfileRequest");
_define_property(GetCompanySbaProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_ended",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompanySbaProfileResponse
 */ export class GetCompanySbaProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanySbaProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanySbaProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanySbaProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanySbaProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.SbaCertFact certifications = 2;
   */ _define_property(this, "certifications", []), /**
   * @generated from field: repeated string naics_small = 3;
   */ _define_property(this, "naicsSmall", []), /**
   * @generated from field: repeated string naics_other_than_small = 4;
   */ _define_property(this, "naicsOtherThanSmall", []), /**
   * @generated from field: string sam_business_size = 5;
   */ _define_property(this, "samBusinessSize", ""), /**
   * @generated from field: repeated mono.datagateway.v1.SbaMpLink mentor_protege = 6;
   */ _define_property(this, "mentorProtege", []), /**
   * @generated from field: string sbs_url = 7;
   */ _define_property(this, "sbsUrl", ""), /**
   * @generated from field: mono.datagateway.v1.SbaSnapshotInfo snapshot = 8;
   */ _define_property(this, "snapshot", void 0), /**
   * the company's UEI ("" ⇒ "Add this company's UEI" state)
   *
   * @generated from field: string uei = 9;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage = 10;
   */ _define_property(this, "cage", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanySbaProfileResponse, "runtime", proto3);
_define_property(GetCompanySbaProfileResponse, "typeName", "mono.datagateway.v1.GetCompanySbaProfileResponse");
_define_property(GetCompanySbaProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "certifications",
            kind: "message",
            T: SbaCertFact,
            repeated: true
        },
        {
            no: 3,
            name: "naics_small",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "naics_other_than_small",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "sam_business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mentor_protege",
            kind: "message",
            T: SbaMpLink,
            repeated: true
        },
        {
            no: 7,
            name: "sbs_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "snapshot",
            kind: "message",
            T: SbaSnapshotInfo
        },
        {
            no: 9,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "cage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanySbaBadgesRequest
 */ export class ListCompanySbaBadgesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanySbaBadgesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanySbaBadgesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanySbaBadgesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanySbaBadgesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * ≤ 100
   *
   * @generated from field: repeated string company_ids = 1;
   */ _define_property(this, "companyIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanySbaBadgesRequest, "runtime", proto3);
_define_property(ListCompanySbaBadgesRequest, "typeName", "mono.datagateway.v1.ListCompanySbaBadgesRequest");
_define_property(ListCompanySbaBadgesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanySbaBadges
 */ export class CompanySbaBadges extends Message {
    static fromBinary(bytes, options) {
        return new CompanySbaBadges().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanySbaBadges().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanySbaBadges().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanySbaBadges, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * MENTOR | PROTEGE
   *
   * @generated from field: repeated string mp_roles = 2;
   */ _define_property(this, "mpRoles", []), /**
   * @generated from field: int32 active_mp_count = 3;
   */ _define_property(this, "activeMpCount", 0), /**
   * @generated from field: repeated string cert_codes = 4;
   */ _define_property(this, "certCodes", []), /**
   * ≤ 3
   *
   * @generated from field: repeated string mp_counterpart_names = 5;
   */ _define_property(this, "mpCounterpartNames", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanySbaBadges, "runtime", proto3);
_define_property(CompanySbaBadges, "typeName", "mono.datagateway.v1.CompanySbaBadges");
_define_property(CompanySbaBadges, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mp_roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "active_mp_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "cert_codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "mp_counterpart_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanySbaBadgesResponse
 */ export class ListCompanySbaBadgesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanySbaBadgesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanySbaBadgesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanySbaBadgesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanySbaBadgesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompanySbaBadges badges = 1;
   */ _define_property(this, "badges", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanySbaBadgesResponse, "runtime", proto3);
_define_property(ListCompanySbaBadgesResponse, "typeName", "mono.datagateway.v1.ListCompanySbaBadgesResponse");
_define_property(ListCompanySbaBadgesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "badges",
            kind: "message",
            T: CompanySbaBadges,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchSbaMentorProtegeAgreementsRequest
 */ export class SearchSbaMentorProtegeAgreementsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchSbaMentorProtegeAgreementsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchSbaMentorProtegeAgreementsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchSbaMentorProtegeAgreementsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchSbaMentorProtegeAgreementsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * ≥ 2 chars: name prefix, or a UEI
   *
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string uei = 2;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: bool include_ended = 3;
   */ _define_property(this, "includeEnded", false), /**
   * ≤ 25
   *
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchSbaMentorProtegeAgreementsRequest, "runtime", proto3);
_define_property(SearchSbaMentorProtegeAgreementsRequest, "typeName", "mono.datagateway.v1.SearchSbaMentorProtegeAgreementsRequest");
_define_property(SearchSbaMentorProtegeAgreementsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_ended",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SbaMpAgreement
 */ export class SbaMpAgreement extends Message {
    static fromBinary(bytes, options) {
        return new SbaMpAgreement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SbaMpAgreement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SbaMpAgreement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SbaMpAgreement, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string agreement_key = 1;
   */ _define_property(this, "agreementKey", ""), /**
   * @generated from field: mono.datagateway.v1.SbaMpParty protege = 2;
   */ _define_property(this, "protege", void 0), /**
   * @generated from field: mono.datagateway.v1.SbaMpParty mentor = 3;
   */ _define_property(this, "mentor", void 0), /**
   * @generated from field: string approved_on = 4;
   */ _define_property(this, "approvedOn", ""), /**
   * @generated from field: string ended_on = 5;
   */ _define_property(this, "endedOn", ""), /**
   * @generated from field: repeated string cert_types = 6;
   */ _define_property(this, "certTypes", []), /**
   * @generated from field: string naics = 7;
   */ _define_property(this, "naics", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SbaMpAgreement, "runtime", proto3);
_define_property(SbaMpAgreement, "typeName", "mono.datagateway.v1.SbaMpAgreement");
_define_property(SbaMpAgreement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "agreement_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "protege",
            kind: "message",
            T: SbaMpParty
        },
        {
            no: 3,
            name: "mentor",
            kind: "message",
            T: SbaMpParty
        },
        {
            no: 4,
            name: "approved_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ended_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cert_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "naics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchSbaMentorProtegeAgreementsResponse
 */ export class SearchSbaMentorProtegeAgreementsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchSbaMentorProtegeAgreementsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchSbaMentorProtegeAgreementsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchSbaMentorProtegeAgreementsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchSbaMentorProtegeAgreementsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SbaMpAgreement agreements = 1;
   */ _define_property(this, "agreements", []), /**
   * @generated from field: mono.datagateway.v1.SbaSnapshotInfo snapshot = 2;
   */ _define_property(this, "snapshot", void 0), /**
   * @generated from field: bool truncated = 3;
   */ _define_property(this, "truncated", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchSbaMentorProtegeAgreementsResponse, "runtime", proto3);
_define_property(SearchSbaMentorProtegeAgreementsResponse, "typeName", "mono.datagateway.v1.SearchSbaMentorProtegeAgreementsResponse");
_define_property(SearchSbaMentorProtegeAgreementsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "agreements",
            kind: "message",
            T: SbaMpAgreement,
            repeated: true
        },
        {
            no: 2,
            name: "snapshot",
            kind: "message",
            T: SbaSnapshotInfo
        },
        {
            no: 3,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
